// extracted by mini-css-extract-plugin
export var content = "_mx-1";
export var fullScreen = "_mx-0";